import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import { TypeLienVisuel } from "../../../../models/taches/gestion-taches.model";
import {TYPES_LIENS_VISUELS} from '../../../../pages/gestion-taches/data/types-lien-affichage';




@Component({
  selector: 'app-choix-type-lien',
  templateUrl: './choix-type-lien.component.html',
  styleUrls: ['./choix-type-lien.component.scss']
})
export class ChoixTypeLienComponent implements OnInit {


  constructor() { }

  @Output() typeLienSelected = new EventEmitter<number>()
  TYPES_LIENS_VISUELS = TYPES_LIENS_VISUELS

  ngOnInit(): void {
  }

  selectType(type: TypeLienVisuel) {
    this.typeLienSelected.emit(type.typeId)
  }
}
